import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import authService from './authService'

const initialState = {
	// admin: admin ? admin : null,
	error: false,
	loading: false,
	success: false,
	message: '',
}

// Admin Login
export const login = createAsyncThunk('auth/login', async (admin, thunkAPI) => {
	try {
		return await authService.login(admin)
	} catch (error) {
		const message =
			(error.response && error.response.data && error.response.data.message) ||
			error.message ||
			error.toString()
		return thunkAPI.rejectWithValue(message)
	}
})

export const authLoginSlice = createSlice({
	name: 'authLogin',
	initialState,
	reducers: {
		reset: (state) => {
			state.loading = false
			state.success = false
			state.error = false
			state.message = ''
			state.admin = null
			state.user = null
		},
	},
	extraReducers: (builder) => {
		builder
			.addCase(login.pending, (state) => {
				state.loading = true
			})
			.addCase(login.fulfilled, (state, action) => {
				state.loading = false
				state.success = true
				state.admin = action.payload
			})
			.addCase(login.rejected, (state, action) => {
				state.loading = false
				state.error = true
				state.message = action.payload
				state.admin = null
			})
	},
})

export const { reset } = authLoginSlice.actions
export default authLoginSlice.reducer
